export default __webpack_public_path__ + "static/media/gallery10.75830af8.png";